import styled from 'styled-components';

const SidebarMobileWrapper = styled.div`
  background-color: ${({ theme }) => theme.palette.background.paper};
  bottom: 0;
  display: flex;
  flex-direction: column;
  font-family: ${({ theme }) => theme.typography.fontFamily};
  font-size: ${({ theme }) => theme.typography.fontSize};
  height: 100vh;
  left: 0;
  line-height: ${({ theme }) => theme.typography.body2.lineHeight};
  position: fixed;
  top: 0;
  transition: width 0.3s ease-out;
  width: 100vw;
  z-index: 99;
  img,
  svg {
    vertical-align: middle;
  }
`;

const ContentWrapper = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  justify-content: space-between;
  overflow-x: auto;
`;

export { ContentWrapper, SidebarMobileWrapper };
